export default __webpack_public_path__ + "static/media/check-icon-lg.a75b46bf.svg";